import * as jsxRuntime from "/home/ubuntu/actions-runner/_work/caresix-web/caresix-web/client/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment